import React from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import Select from "react-select";

import ConditionalButton from "../../../../../layout/conditional-button";

const MATTER_STYLE_OPTIONS = [
    { value: "Other", label: "Other" },
    { value: "Civil", label: "Civil" },
    { value: "Domestic", label: "Domestic" },
    { value: "Criminal", label: "Criminal" },
    { value: "Probate", label: "Probate" },
    { value: "Juvenile", label: "Juvenile" },
    { value: "Traffic", label: "Traffic" },
    { value: "Administrative", label: "Administrative" },
    { value: "Special", label: "Special" },
];

const MATTER_FLAG_OPTIONS = [
    { value: 1, label: "Divorce" },
    { value: 2, label: "Custody/Visitation" },
    { value: 4, label: "Child Support" },
    { value: 8, label: "Spousal Support" },
    { value: 16, label: "General Civil" },
    { value: 32, label: "General Criminal" },
    { value: 64, label: "Traffic" },
    { value: 128, label: "Personal Injury" },
    { value: 256, label: "Name Change" },
];

class LeadConversionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.mapPropsToState(props);
    }

    mapPropsToState = (props) => ({
        createMatter: false,
        matterCaption: props.defaultCaption || "",
        matterStyle: "Other",
        matterFlags: 0,
    });

    componentDidUpdate(oldProps) {
        if (oldProps.show !== this.props.show || oldProps.defaultCaption !== this.props.defaultCaption) {
            this.setState(this.mapPropsToState(this.props));
        }
    }

    onHideModal = (e) => {
        if (this.props.onCancel) this.props.onCancel(e);
    };

    onChange = (e) => {
        const { name, value, checked, type } = e.target;
        this.setState({ [name]: type === "checkbox" ? checked : value });
    };

    onStyleChange = (option) => {
        this.setState({ matterStyle: option?.value || "Other" });
    };

    onFlagChange = (e) => {
        const flag = Number(e.target.value || 0);
        this.setState((prev) => ({
            matterFlags: e.target.checked
                ? Number(prev.matterFlags || 0) | flag
                : Number(prev.matterFlags || 0) & ~flag,
        }));
    };

    onOk = async () => {
        if (!this.canSave) return;
        if (this.props.onOk) {
            await this.props.onOk({
                createMatter: this.state.createMatter,
                matterCaption: this.state.createMatter ? this.state.matterCaption : null,
                matterStyle: this.state.createMatter ? this.state.matterStyle : null,
                matterFlags: this.state.createMatter ? this.state.matterFlags : 0,
            });
        }
    };

    get canSave() {
        if (!this.state.createMatter) return true;
        return Boolean(String(this.state.matterCaption || "").trim());
    }

    renderMatterFields = () => {
        if (!this.state.createMatter) return null;

        return (
            <Row className="g-3 mt-2">
                <Col xs="12">
                    <div className="top-label">
                        <Form.Control
                            type="text"
                            name="matterCaption"
                            value={this.state.matterCaption}
                            onChange={this.onChange}
                        />
                        <Form.Label>MATTER CAPTION</Form.Label>
                    </div>
                </Col>
                <Col md="6">
                    <div className="top-label">
                        <Select
                            inputId="leadConversionMatterStyle"
                            classNamePrefix="react-select"
                            options={MATTER_STYLE_OPTIONS}
                            value={MATTER_STYLE_OPTIONS.find((option) => option.value === this.state.matterStyle) || MATTER_STYLE_OPTIONS[0]}
                            onChange={this.onStyleChange}
                        />
                        <Form.Label>STYLE</Form.Label>
                    </div>
                </Col>
                <Col xs="12">
                    <Form.Label>MATTER TYPE</Form.Label>
                    <div className="d-flex flex-wrap">
                        {MATTER_FLAG_OPTIONS.map((option) => (
                            <Form.Check
                                key={option.value}
                                className="me-4 mb-2"
                                type="checkbox"
                                id={`lead-conversion-matter-flag-${option.value}`}
                                value={option.value}
                                checked={Boolean(Number(this.state.matterFlags || 0) & option.value)}
                                onChange={this.onFlagChange}
                                label={option.label}
                            />
                        ))}
                    </div>
                </Col>
            </Row>
        );
    };

    render() {
        return (
            <Modal size="lg" backdrop="static" keyboard show={this.props.show} onHide={this.onHideModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="staticBackdropLabel">Convert Lead</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-3">
                        <Col xs="12">
                            <div className="text-muted">
                                This will mark the lead won, create or update the client profile, and close open lead follow-ups.
                            </div>
                        </Col>
                        <Col xs="12">
                            <Form.Check
                                type="checkbox"
                                id="lead-conversion-create-matter"
                                name="createMatter"
                                checked={this.state.createMatter}
                                onChange={this.onChange}
                                label="Create the first matter"
                            />
                        </Col>
                    </Row>
                    {this.renderMatterFields()}
                </Modal.Body>
                <Modal.Footer>
                    <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.onHideModal} icon="error-hexagon">cancel</ConditionalButton>
                    <ConditionalButton enabledVariant="outline-primary" display enabled={this.canSave} onEnabledClick={this.onOk} icon="save">ok</ConditionalButton>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default LeadConversionModal;
